import React, { useEffect, useState } from "react";
import useReactRouter from "use-react-router"
import * as _ from "lodash"
import { Breadcrumb } from "react-bootstrap";
import { COLOR_APP } from "../../constants";
import HelpBeginner from "./HelpBeginner";
import HelpMessageSetting from "./HelpMessageSetting";

function HelpCenter() {
    const { history } = useReactRouter()
    const [pageSelected, setPageSelected] = useState("BEGINNER");


    useEffect(() => {

    }, [])


    return (
        <div>
            <div className="row" style={{margin:0}}>
                <div className="col-2" style={{ background: COLOR_APP, height: "100vh",padding:0 }}>
                    <div style={{ height: 20 }} />
                    <p style={{ margin: 0, fontSize: 20, color: "#fff", fontWeight: "bold" }} className="text-center">ຄູ່ມືການໃຊ້ງານ</p>
                    <p style={{ margin: 0, fontSize: 24, color: "#fff", fontWeight: "bold" }} className="text-center">4B CF</p>
                    <div style={{ height: 20 }} />
                    <ul className="list-group" style={{borderRadius:0, background:"rgba(0,0,0,0)"}}>
                        <li className="list-group-item  list-group-item-action hoverme" 
                        onClick={()=>setPageSelected("BEGINNER")}
                        style={{ background:"rgba(0,0,0,0)",color: "#fff",}}>ເລີ່ມຕົ້ນໃຊ້ງານ</li>
                        {/* <li className="list-group-item  list-group-item-action hoverme" 
                        onClick={()=>setPageSelected("MESSAGE_SETTING")}
                        style={{ background:"rgba(0,0,0,0)",color: "#fff",}}>ຕັ້ງຄ່າຂໍ້ຄວາມຕອບກັບ</li> */}
                    </ul>
                </div>
                <div className="col-10">
                    {pageSelected == "BEGINNER"&&<HelpBeginner />}
                    {pageSelected == "MESSAGE_SETTING"&&<HelpMessageSetting />}
                </div>
            </div >
        </div >
    );
}

export default HelpCenter;